import type { HTMLAttributes, ReactNode } from "react";
import styles from "./BottomCTA.module.css";
import { cx } from "../cx";
import { ActionButton, type ActionButtonProps } from "../components/ActionButton";

export type BottomCTAProps = HTMLAttributes<HTMLDivElement> & {
  primary: Omit<ActionButtonProps, "size" | "block"> & { children: ReactNode };
  /** 보조(ghost small) */
  secondary?: Omit<ActionButtonProps, "size" | "block" | "variant"> & { children: ReactNode };
  /** 화면 하단 고정 여부 (기본 true) */
  fixed?: boolean;
};

/** 하단 고정 CTA (Figma 97:3853). bg/layer-default, 하단 safe area 34. */
export function BottomCTA({ primary, secondary, fixed = true, className, ...rest }: BottomCTAProps) {
  return (
    <div className={cx(styles.root, fixed ? styles.fixed : styles.inline, className)} {...rest}>
      <ActionButton size="medium" block {...primary} />
      {secondary && <ActionButton size="small" block variant="ghost" {...secondary} />}
    </div>
  );
}
